module.exports = __webpack_public_path__ + "img/foot-logo.3c0f9e70.png";